/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import fondoQuienesSomos from '../../assets/QUIENES-SOMOS---FONDO.png';
import './InfoBiomercy.css';

const InfoBiomercy = ({ onVerQuienesSomos }) => {
  const footerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const target = footerRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    observer.observe(target);
    return () => observer.unobserve(target);
  }, []);

  return (
    <section className="info-biomercy">
      {/* Imagen de fondo */}
      <div
        className="background-image"
        style={{
          backgroundImage: `url(${fondoQuienesSomos})`,
        }}
      ></div>

      {/* Contenido principal */}
      <div className="main-content">
        <div className="content-container">
          {/* Título */}
          <div className="title-section">
            <h2 className="main-title">
              ¿Quiénes <span className="normal-weight">somos?</span>
            </h2>
          </div>

          {/* Sección de texto */}
          <div className="text-section">
            <div className="text-content">
              <p>
                Somos una empresa comprometida con la salud y el bienestar de
                todos los venezolanos. Nuestro propósito es claro: Innovar con
                propósito, asegurando que cada uno de nuestros productos cumpla
                con los más altos estándares de calidad.
              </p>
              <p>
                Además, a través de BioMercy® nos preocupamos no solo por la
                efectividad de nuestros productos, sino también por su
                accesibilidad y el trato personalizado que ofrecemos a la
                población venezolana. Trabajamos en estrecha colaboración con
                los profesionales de la salud y las autoridades reguladoras para
                garantizar que nuestros medicamentos cumplan con los más altos
                estándares de calidad y seguridad.
              </p>
            </div>
          </div>

          {/* Botón */}
          {/* <div className="button-section">
            <div 
              className="mas-informacion-btn"
              onClick={onVerQuienesSomos}
            >
              Más Información
            </div>
          </div> */}
        </div>
      </div>
      {/* Sección gris */}
      <div className="gray-section" ref={footerRef}></div>

      {/* Sección blanca */}
      <div className="white-section"></div>
    </section>
  );
};

export default InfoBiomercy;
